export const AUDIT_ENTERPRISE_CREATE_PAGE_PATH = '/audit/enterprise/create'

export const AUDIT_ENTERPRISE_EDIT_PAGE_PATH = '/audit/enterprise/edit'

export const AUDIT_ENTERPRISE_DETAIL_PAGE_PATH = '/audit/enterprise/detail'

export const AUDIT_ENTERPRISE_RESULT_PAGE_PATH = '/audit/enterprise/result'
